'use client';

import { motion } from 'motion/react';

import { CMSLink } from '@/components/Link';
import { useLocale } from '@/contexts/LocaleContext';
import {
  CareerList,
  EmployeesSpot as EmployeesSpotType,
} from '@/payload-types';
import { cn } from '@/utils/cn';
import { getDictionary } from '@/utils/getDictionary';

import styles from './EmployeesSpot.module.scss';

type Props = {
  className?: string;
  employeeSpotContent: {
    employeesSpot: EmployeesSpotType | false;
    careers: CareerList | false;
  };
};

export const EmployeesSpotClient: React.FC<Props> = (props) => {
  const { className, employeeSpotContent } = props;
  const locale = useLocale();
  const t = getDictionary(locale);

  const { careers, employeesSpot } = employeeSpotContent;

  if (!employeesSpot) return null;

  if (!careers) {
    return null;
  }

  const { description, link, title } = employeesSpot;

  return (
    <motion.div className={cn(styles.spot, className)}>
      {title && <div className={styles.title}>{title}</div>}
      {description && <div className={styles.description}>{description}</div>}
      {careers && (
        <div className={styles.careers}>
          {careers.length} {t('employee.vacancies')}
        </div>
      )}
      {link && (
        <div className={styles.link}>
          <CMSLink {...link} appearance='level-3' className='button--medium' />
        </div>
      )}
    </motion.div>
  );
};
